import * as React from 'react';
import Icon from '../../../../banner/partials/Icon';

export default function Links({links}) {
  if (!Array.isArray(links) || links.length === 0) return null;

  return (
    <div className='links'>
      {links.map(entry => {
        const {provider, url, label} = entry;
        return (
          <Icon key={url} url={url} platform={provider} target='_blank' rel='noopener noreferrer' ariaLabel={label}/>
        );
      })}
    </div>
  );
}
